module.exports = __webpack_public_path__ + "img/default-member.3f42c871.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default-member.png
// module id = rA+B
// module chunks = 1